import { SCHEDULE_TYPES } from '../constants/horario.types'
import {ScheduleAction, ScheduleState} from '../interfaces/horario.interfaces'

const initialState: ScheduleState = {
  selectedSucursal: null,
  dataEmpresa: null,
  dataSucursales: [],
  formHorario: {
    sinHorario: false,
    horaInicio: '',
    horaFin: '',
  },
  errorsHorario: {
    sinHorario: '',
    horaInicio: '',
    horaFin: '',
  }
}

const horarioReducer = (
  state: ScheduleState = initialState,
  action: ScheduleAction
): ScheduleState => {
  switch (action.type) {
    case SCHEDULE_TYPES.SDL_SET_DATA_EMPRESA:
      return {...state, dataEmpresa: action.payload}
    case SCHEDULE_TYPES.SDL_SET_DATA_SUCURSALES:
      return {...state, dataSucursales: action.payload}
    case SCHEDULE_TYPES.SDL_SET_SUCURSAL_SELECTED:
      return {...state, selectedSucursal: action.payload}
    case SCHEDULE_TYPES.SDL_SET_FORM_HORARIO:
      return {...state, formHorario: {...state.formHorario, ...action.payload}}
    case SCHEDULE_TYPES.SDL_SET_ERRORS_FORM_HORARIO:
      return {...state, errorsHorario: {...state.errorsHorario, ...action.payload}}
    default:
      return state
  }
}

export default horarioReducer
